import { render } from "./Tree.vue?vue&type=template&id=7bd545da"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"

import "./Tree.vue?vue&type=style&index=0&id=7bd545da&lang=scss"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__